module.exports = __webpack_public_path__ + "static/media/Membership video script draft_1609574788124.745fd5ca.docx";